export const compressImage = (url, params) => {
  if (url.endsWith(".mp4") || url.endsWith(".gif")) return url;
  //前置判断处理base64url
  const reg = RegExp(/data:image\/.*;base64,/);
  const isBaseUrl = reg.test(url);
  if (isBaseUrl || !url) return url;
  // 是否已经压缩过 || 本地文件
  if (url.includes("?") || url.startsWith("blob")) return url;
  const defaultParams = {
    format: "webp"
  };
  const _params = Object.assign(defaultParams, params);
  if (!_params.resize) {
    return url + "?format=".concat(_params.format);
  }
  return url + "?format=".concat(_params.format, "&args=pr:empty/rs:fill:").concat(_params.resize, ":0");
};